import { render, staticRenderFns } from "./AcademicCard.vue?vue&type=template&id=012eb164&scoped=true"
import script from "./AcademicCard.vue?vue&type=script&lang=js"
export * from "./AcademicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012eb164",
  null
  
)

export default component.exports